export const allergensList : string[] = ['Cereals containing gluten','Crustaceans','Eggs','Fish','Peanuts','Soybeans','Milk',
'Nuts','Celery','Mustard','Sesame','Sulphur dioxide and Sulphates ','Lupin','Molluscs'];